import React from 'react'
import styles from './index.module.scss'

export type ReportEntryProps = {
  url?: string | null
}

const ReportEntry: React.FC<ReportEntryProps> = (props) => {
  const { url } = props

  return url ? (
    <a href={url} className={styles.container}>
      <img src={require('../../../../../assets/maint-report.png')} />
    </a>
  ) : null
}

export default ReportEntry
